<template>
  <li
    v-if="member"
    class="members__item member mx-3 py-2"
    @click="onClickMember">
    <div class="d-flex align-items-center">
      <div>
        <img
          v-if="member.avatar"
          class="img-fluid rounded-circle member__img mr-3"
          :src="member.avatar">
        <p v-else>
          <MaterialIcon
            icon="person"
            class="member__icon mr-3" />
        </p>
      </div>
      <div class="flex-grow-1">
        <div
          class="d-flex justify-content-between align-items-baseline container">
          <div
            class="d-flex align-items-baseline member-text"
            :class="{'searched': isSearched, 'active': active}">
            <div
              v-if="isAdmin"
              class="mr-1">
              <strong> 
                {{ member.sortNo | prettySortNo }}
              </strong>
            </div>
            <div class="member__content">
              <p
                class="member__name">
                <UserTag :user="member" />
                {{ member.name }}
              </p>
              <p
                v-if="studentNumberOption && studentNumberText"
                class="member__student-number">
                {{ studentNumberText }}
              </p>
            </div>
            <p
              v-if="isManager && member.finalDestination"
              class="member__title">
              {{ member.finalDestination.destinationName }}
            </p>
            <p
              v-else
              class="member__title">
              {{ member.position }}
            </p>
            <button
              v-if="isAdmin && !member.isActive"
              class="btn btn-interested btn-secondary btn--small ml-1">
              <span class="material-icons btn-interested-icon">
                not_interested
              </span>
              利用停止中
            </button>
          </div>
          <div class="members__item__suffix">
            <slot name="suffix" />
          </div>
        </div>
        <slot />
      </div>
    </div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import { getStudentNumberText } from '@/helper/profile'
import UserTag from '@/components/parts/UserTag.vue'
export default {
  components: {
    UserTag
  },
  props: {
    member: {
      type: Object,
      default: null
    },
    isSearched: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isManager']),
    ...mapGetters('tenant', ['studentNumberOption']),
    studentNumberText() {
      return this.member ? getStudentNumberText(this.member) : ''
    },
  },
  methods: {
    onClickMember() {
      if (this.isAdmin){
        this.$router.push(`/admin/members/${this.member.id}/edit`, () => {})
      } else {
        this.$store.commit('departments/setReturnMember', {
          memberId: this.member.id,
          departmentId: this.member.department.id,
        })
        this.$router.push(`/members/${this.member.id}`, () => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/members';
@import '@/assets/stylesheets/member';
.btn-interested{
    margin: 0 0 0 auto;
  }

.btn-interested-icon{
  font-size: 18px;
  display: inline-block;
  vertical-align: text-bottom;
}

.container {
  padding: 5px 0;
}

.member-text {
  width: 100%;
  margin-right: 10px;
  margin-left: -10px;
  border-radius: 5px;
  padding: 5px 10px;

  &.searched {
    background: $highlight;
  }

  &.active {
    background-color: $highlight;
  }
}

.member__title {
  margin-left: auto;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 120px;
}

.member__student-number {
  font-size: $fs-s;
  color: $grey05;
  line-height: 150%;
  margin-bottom: 0;
}
</style>
